import script from "./starDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./starDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./starDisplay.vue?vue&type=style&index=0&id=1f3c156e&lang=scss"

const __exports__ = script;

export default __exports__